import fetchApi from 'utils/fetchApi'
import { getApiUrl } from 'utils/urlBuilder'

type CurrencyBalance = {
  [currency: string]: Array<number>
}

// AccountBalance = [{ "USD": [1, 2, 3] }, { "GBP": [50, 250, 100] }]
export type AccountBalance = Array<CurrencyBalance>

export const getBalances = () =>
  fetchApi<AccountBalance>({
    auth: true,
    method: 'GET',
    url: getApiUrl('nabu-gateway/accounts/mercury')
  })
